// getOrders returns a list of  orders per page placed by the customer
// in the past five years . 100 is the upperlimit
export const OrdersService_getOrdersLazy = () =>
  import("./orders_service.grpc").then((m) => m.OrdersService_getOrders);
OrdersService_getOrdersLazy.method =
  "orders.v1.OrdersService/getOrders" as const;

// getOrderDetailById returns a single order with details
export const OrdersService_getOrderDetailByIdLazy = () =>
  import("./orders_service.grpc").then(
    (m) => m.OrdersService_getOrderDetailById
  );
OrdersService_getOrderDetailByIdLazy.method =
  "orders.v1.OrdersService/getOrderDetailById" as const;

// cancelOrder cancels an order
// https://bitbucket.collins.kg/projects/ASS/repos/coba---checkout-api/browse/order-cancel
//
// For "known errors" (cancellation impossible, cancellation already attempted earlier) this does not return an error, but rather communicates this using the `cancellationStatus` response field
export const OrdersService_cancelOrderLazy = () =>
  import("./orders_service.grpc").then((m) => m.OrdersService_cancelOrder);
OrdersService_cancelOrderLazy.method =
  "orders.v1.OrdersService/cancelOrder" as const;

// getShipmentTracking proxies shipment tracking data from RDS
// https://bitbucket.collins.kg/projects/RDS/repos/rds-api-doc/browse/fetch-shipment-tracking-timeline
// with fallback from CO:
// https://bitbucket.collins.kg/projects/ASS/repos/coba---checkout-api/browse/shipment-tracking
export const OrdersService_getShipmentTrackingLazy = () =>
  import("./orders_service.grpc").then(
    (m) => m.OrdersService_getShipmentTracking
  );
OrdersService_getShipmentTrackingLazy.method =
  "orders.v1.OrdersService/getShipmentTracking" as const;

// createReturnDocument initiates are return for the given order (and optionally only the specified package)
//
// Returns the updated order
// If a specific pick-up date was specified, this is reflected in the order,
// else the order contains the return documents (for the box and package label).
//
// https://bitbucket.collins.kg/projects/ASS/repos/coba---checkout-api/browse/return-document-create
export const OrdersService_createReturnDocumentLazy = () =>
  import("./orders_service.grpc").then(
    (m) => m.OrdersService_createReturnDocument
  );
OrdersService_createReturnDocumentLazy.method =
  "orders.v1.OrdersService/createReturnDocument" as const;

// DownloadDocument returns the document based on the provided url from checkout
export const OrdersService_DownloadDocumentLazy = () =>
  import("./orders_service.grpc").then((m) => m.OrdersService_DownloadDocument);
OrdersService_DownloadDocumentLazy.method =
  "orders.v1.OrdersService/DownloadDocument" as const;
